import Vue2Filters from 'vue2-filters'
import { date, datetime } from './moment'
import { abbreviateName } from './abbreviateName'

export default {
  install (Vue) {
    Vue.filter('date', date)
    Vue.filter('datetime', datetime)
    Vue.use(Vue2Filters)
    Vue.filter('abbreviateName', abbreviateName)
  }
}
